<template>
  <ConfirmGenerateTokenModal />
  <div class="row" v-if="getConfigurations != null">
    <div class="col-lg-12">
      <div class="card mb-25 border-0 radius-7 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <h5 class="card-title fw-bold mb-25 mb-md-25 mb-lg-25 text-center">
            Atualizar informações
          </h5>
          <div class="mt-30" id="myTabContent" v-if="getOperation != null">
            <form v-on:submit="saveConfigurations()">
              <div class="show active row" id="overviewPreview-tab-pane" role="tabpanel" tabindex="0">
                
                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="operation_name" class="form-label fw-medium">Nome da operação</label>
                  <input
                    :value="getOperation.name"
                    type="text"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="operation_name"
                    autocomplete="off"
                  />
                </div>

                <div class="d-flex flex-column col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex">
                  <label for="overviewEmail" class="form-label fw-medium col-6">Token</label>
                  <div class="d-flex flex-row col-12">
                    <input
                      :value="getOperation.token"
                      type="text"
                      class="form-input-token-custom form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="token"
                      autocomplete="off"
                      disabled
                    />
                    <span data-bs-toggle="modal" data-bs-target="#ViewGenerateTokenModal" class="pointer input-group-text area-icon-refresh-token form-input-button-token-custom" id="basic-addon2"><i class="flaticon flaticon-refresh"></i></span>
                  </div>
                  <div class="form-text mb-15 mb-mb-15 mb-md-20 col-12">
                    O token é utilizado para realizar o upload de gravações, alterá-lo pode impactar diretamente nos próximos uploads.
                  </div>
                  
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="operation_status" class="form-label fw-medium">Status</label>
                  <select id="operation_status" class="form-select shadow-none text-black fs-md-15" required>
                    <option :selected="getOperation.active == '1'" value="1">Sim</option>
                    <option :selected="getOperation.active == '0'" value="0">Não</option>
                  </select>
                </div>

                <h5 class="mt-30 card-title fw-bold mb-25 text-center">
                  Funcionalidades de inteligência artificial:
                </h5>

                <div class="alert alert-info d-flex align-items-center fs-md-10 fs-lg-10 alert-price-ia ms-2" role="alert">
                  <i class="flaticon-money lh-1 fs-20 position-relative top-1 me-8"></i>
                  As funcionalidades de Inteligência Artificial possuem custos adicionais, verifique em nossa página de pagamentos para mais informações.
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="needs_transcription" class="form-label fw-medium">Transcrição da gravação</label>
                  <select @change="changeTranscript" v-model="needs_transcription" id="needs_transcription" class="form-select shadow-none text-black fs-md-15" required>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="needs_sentiment_analysis" class="form-label fw-medium">Análise de sentimento (somente com transcrição)</label>
                  <select :disabled="needs_transcription == '0'" v-model="needs_sentiment_analysis" id="needs_sentiment_analysis" class="form-select shadow-none text-black fs-md-15" required>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>

                <div class="form-text mb-25 col-12">
                  <p>As funcionalidades de Inteligência Artificial, como transcrição automática de áudios e análise de sentimento das gravações de telefonia, devem ser utilizadas somente com a autorização do cliente envolvido. Em conformidade com a Lei Geral de Proteção de Dados (LGPD), é responsabilidade do usuário garantir que possui essa permissão.
                  Ao ativar e utilizar essas funcionalidades, entendemos que você declara ter obtido o consentimento necessário para processar os dados das gravações por meio de IA.</p>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="password" class="form-label fw-medium">Senha para confirmar alteração</label>
                  <input
                    type="password"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="password"
                    autocomplete="off"
                    required
                  />
                </div>

                <div class="col-12 justify-content-center d-flex">
                  <button ref="buttonSubmitConfigurationUpdate" type="submit" class="btn btn-primary mt-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">Salvar informações</button>
                </div>

                <div class="col-12">
                  <div id="alertResponseApi" class="toast align-items-center text-bg-success border-0 w-100 mt-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="d-flex">
                      <div class="toast-body fs-md-15 fs-lg-16" id="errorMessage"></div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../config/axios.js';
import ConfirmGenerateTokenModal from './ConfirmGenerateTokenModal.vue';


export default {
  name: "FormsOverview",
  data() {
    return {
      responseApi: {},
      needs_transcription: 0,
      needs_sentiment_analysis: 0
    }
  },
  components: {
    ConfirmGenerateTokenModal
  },
  mounted(){
    if(this.$route.params.id != null){
      this.setOperation(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters([
      'getConfigurations',
      'getOperation'
    ])
  },
  watch: {
    getConfigurations(data){
      this.phone1 = data.commercial_phone_01;
    },
    getOperation(data){
      this.needs_transcription = data.needs_transcription;
      this.needs_sentiment_analysis = data.needs_sentiment_analysis;
    }
  },
  methods: {
    ...mapActions([
      "setOperation"
    ]),
    changeTranscript(){
      if(this.needs_transcription == "0"){
        this.needs_sentiment_analysis = "0"
      }
    },
    closeAlert(){
      const elementAlert = document.getElementById("alertResponseApi");
      if(elementAlert){
        elementAlert.style.display = "none";
      }
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessage").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessage").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApi");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password");
      if(password){
        password.value = "";
      }
    },
    saveConfigurations(){
      event.preventDefault();

      if(
        document.getElementById("operation_name") == undefined ||
        document.getElementById("operation_name").value == "" ||
        this.needs_transcription == undefined ||
        document.getElementById("password") == undefined ||
        document.getElementById("password").value == "" ||
        document.getElementById("password").value.length < 8 ||
        document.getElementById("operation_status").value == ""
      ){
        this.alertResponse("Erro, verifique os campos e tente novamente !", true);
        return;
      }

      const operation_id = this.$route.params.id;
      const operation_name = document.getElementById("operation_name").value;
      const password = document.getElementById("password").value;
      const operation_status = document.getElementById("operation_status").value;

      const needs_transcription = this.needs_transcription ? this.needs_transcription : "0";
      const needs_sentiment_analysis = this.needs_transcription == "1" && this.needs_sentiment_analysis ? this.needs_sentiment_analysis : "0" ;

      const configuration = {
        "operation_id": operation_id,
        "operation_name": operation_name,
        "password": password,
        "operation_status": operation_status,
        "needs_transcription": needs_transcription,
        "needs_sentiment_analysis": needs_sentiment_analysis
      }

      const buttonSubmitConfigurationUpdate = this.$refs.buttonSubmitConfigurationUpdate;
      buttonSubmitConfigurationUpdate.disabled = true;
      buttonSubmitConfigurationUpdate.innerHTML = "Salvando...";

      const alertResponse = this.alertResponse;
        api.axios.put('/api/update/operation/configuration', configuration).catch(function(error){
          if(error.response.data != undefined){
            alertResponse(error.response.data.message, true);
          }
        }).then(function(response){
          buttonSubmitConfigurationUpdate.disabled = false;
          buttonSubmitConfigurationUpdate.innerHTML = "Salvar informações";
          if(response != undefined && response.status == 200){
            alertResponse(response.data.message, false);
            window.location.reload();
          }
        });

    }
  }
};
</script>

<style scoped>
.form-input-token-custom {
  border-bottom-right-radius: unset !important;
  border-top-right-radius: unset !important;
}

.form-input-button-token-custom {
  border-bottom-left-radius: unset !important;
  border-top-left-radius: unset !important;
}

.alert-price-ia{
  width: 98%;
  margin-left: 12px !important;
}

@media (max-width: 768px) {
  .alert-price-ia{
      width: 93%;
      margin-right: auto;
      margin-left: auto;
  }
}
</style>